import React from 'react';
import styled from 'styled-components';

const ErrorContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  background: #ffffff;
  min-height: 300px;
`;

const ErrorIcon = styled.div`
  font-size: 48px;
  margin-bottom: 16px;
  color: #ef4444;
`;

const ErrorTitle = styled.h2`
  color: #1f2937;
  font-size: 20px;
  font-weight: 600;
  margin: 0 0 8px 0;
  text-align: center;
`;

const ErrorMessage = styled.p`
  color: #6b7280;
  font-size: 14px;
  margin: 0 0 24px 0;
  text-align: center;
  max-width: 300px;
  line-height: 1.5;
`;

const RetryButton = styled.button`
  background: #275386;
  color: white;
  border: none;
  border-radius: 8px;
  padding: 12px 24px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  gap: 8px;

  &:hover {
    background: #1f4470;
    transform: translateY(-1px);
  }

  &:active {
    transform: translateY(0);
  }

  &:disabled {
    background: #9ca3af;
    cursor: not-allowed;
    transform: none;
  }
`;

const RetryIcon = styled.span`
  font-size: 16px;
`;

const ConnectionError = ({ onRetry, isRetrying = false, retryCount = 0 }) => {
  return (
    <ErrorContainer>
      {/* <ErrorIcon>🔌</ErrorIcon> */}
      <ErrorTitle>Connection Failed</ErrorTitle>
      <ErrorMessage>
        Unable to connect to the chat service. Please check your internet connection and try again.
        {retryCount > 0 && ` (Attempt ${retryCount + 1})`}
      </ErrorMessage>
      <RetryButton onClick={onRetry} disabled={isRetrying}>
        <RetryIcon aria-hidden="true">↻</RetryIcon>
        {isRetrying ? 'Retrying...' : 'Retry Connection'}
      </RetryButton>
    </ErrorContainer>
  );
};

export default ConnectionError; 